import { useAccessState } from 'modules/common';
import { InstallationItem } from 'modules/components/layer19';
import { DailyReportCardLayout } from 'modules/components/layer05';
import { SaveDecisionModal } from 'modules/components/layer17';
import React, { useState } from 'react';
import * as ds from './dataService';
import { useParams } from 'react-router-dom';
import { Typography } from '@mui/material';


export type InstallationDecisionCardProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: InstallationDecisionCardProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.installationId ?? '');
  const access = useAccessState('Decision');
  const [
    fnRemoveDecision,
    { loading }
  ] = ds.useRemoveDecision();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  return (
    <>
      {isVisible && (
        <SaveDecisionModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}

      <DailyReportCardLayout.FC
        title='Decisions'
        subTitle='List of all decisions that need to to be made for this finish.'


        actionButton={{
          text: 'Add new decision',
          onClick: () => {
            setIsVisible(() => true);
          },
          disabled: !access.create
        }}
      >
        {data.map((node, i) => (
          <InstallationItem.FC
            key={i}
            id={node.decisionId}
            disableEdit={loading || !access.update}
            title={node.title}
            installationItemType='DECISION'
            itemState={node.itemState}
            disableRemove={!access.delete}
            handleRemove={async () => {
              await fnRemoveDecision(node.decisionId);
            }}
          >
            <Typography
              variant='formLabel'
            >
              Due At:
              {/* {props.formLabelText} */}
            </Typography>

            <Typography
              variant='formInput'
            >
              {/* {props.formInputText} */}
              {node.dueDate.toFormat('DDDD')}
            </Typography>

          </InstallationItem.FC>
        ))}
      </DailyReportCardLayout.FC>
    </>
  );
};
